import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

export interface CartRecapLine {
  key: string;
  label: string;
  // Price tag, or ticket type of a discount
  detail?: string;
  quantity: number;
  amount: number;
  // Discount line (success color, negative amount)
  discount?: boolean;
  // Plain circle before the label: ticket type color (null: primary)
  dot?: boolean;
  color?: string | null;
}

export interface CartRecapGroup {
  key: string;
  // Hidden when empty
  title: string;
  lines: CartRecapLine[];
}

/** Running total of a selection step (primary tinted glass), optionally with the cart lines. */
@Component({
  selector: 'app-order-total',
  templateUrl: './order-total.component.html',
  styleUrls: ['./order-total.component.scss'],
  standalone: true,
  imports: [DecimalPipe, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderTotalComponent {
  @Input() amount: number = 0;
  @Input() vat: number = 0;
  // Total before discount, stacked above the amount when greater
  @Input() originalAmount: number | null = null;
  @Input() groups: CartRecapGroup[] | null = null;
  // Quiet CTA under the total (e.g. promo code), hidden when null
  @Input() actionLabel: string | null = null;
  @Output() action = new EventEmitter<void>();

  // A discount lowered the total (0.00€ is then displayed instead of "-")
  get isDiscounted(): boolean {
    return this.originalAmount !== null && this.originalAmount > this.amount;
  }
}
